<template>
    <div class="offerAffirm ben-fff-bg">
        <div class="aff-title ben-fff-color ben-size-14 ben-align-center">产品报价</div>
        <van-row class="info-list-comm ben-border-t">
                <van-col span="8" class="title-left">
                    <span class="ben-000-color ben-size-14">产品报价</span>
                </van-col>
                <van-col span="12" class="ben-000-color ben-size-14 title-right"> 
                    <van-field v-model="digitNum" placeholder="请输入产品报价" type="number" maxlength="9" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
                </van-col>
                <van-col span="4" class="ben-000-color ben-size-14 ben-align-right">元/{{clickOfferDetail.unit}}</van-col>
        </van-row>
        <van-row class="info-list-comm ben-border-t">
                <van-col span="8" class="title-left">
                    <span class="ben-333-color ben-size-14">备注</span>
                </van-col>
                <van-col span="16" class="ben-000-color ben-size-14 title-right"> 
                    <van-field v-model="digitcomm" :autosize=autosize type="textarea" maxlength="200" 
                        placeholder="(非必填项)给买家留言" />
                </van-col>
        </van-row>
        <div class="aff-info">
            <van-row class="">
                <van-col span="8" class="title-left">
                    <span class="ben-80-color ben-size-12">采购商品</span>
                </van-col>
                <van-col span="16" class="ben-000-color ben-size-12 title-right"> 
                   <span>{{clickOfferDetail.goods_name}}</span>
                </van-col>
            </van-row>
            <van-row class="">
                <van-col span="8" class="title-left">
                    <span class="ben-80-color ben-size-12">数量</span>
                </van-col>
                <van-col span="16" class="ben-000-color ben-size-12 title-right"> 
                   <span>{{clickOfferDetail.buy_num}}{{clickOfferDetail.unit}}</span>
                </van-col>
            </van-row>
            <van-row class="">
                <van-col span="8" class="title-left">
                    <span class="ben-80-color ben-size-12">目标单价</span>
                </van-col>
                <van-col span="16" class="ben-000-color ben-size-12 title-right"> 
                   <span>￥{{utils.num_format((clickOfferDetail.target_unit_price/100).toFixed(2))}}</span>
                </van-col>
            </van-row>
            <van-row class="">
                <van-col span="8" class="title-left">
                    <span class="ben-80-color ben-size-12">产品描述</span>
                </van-col>
                <van-col span="16" class="ben-000-color ben-size-12 title-right">
                   <span v-if="clickOfferDetail.goods_describe&&clickOfferDetail.goods_describe!==''">{{clickOfferDetail.goods_describe}}</span>

                    <span v-else>暂无描述</span>
                </van-col>
            </van-row>
        </div>
        <div class="aff-bottom ben-align-center">
            <button class="ben-btn-r ben-fff-color ben-size-13 123" @click="clickBtnOffer">确认报价</button>
        </div>
       
    </div>
</template>
<script>
export default {
    name:'offerAffirm',
    props : {
        clickOfferDetail :{
            type : Object
        },
        data : {
            type : Object
        }
    },
    components: {
    },
    data () {
        return {
        digitNum : '',
        digitcomm : "",
            autosize : {
                maxHeight: 50, minHeight: 30
            }
        }
    },
    created () {
        
    },
    methods: {
        clickBtnOffer(){
            if(this.digitNum==""){
                this.Toast("请填写产品报价")
                return false
            }
            if((Number(this.digitNum)*100)>=100000000000){
                this.Toast("产品报价过大")
                return false
            }
            if(Number(this.digitNum)<=0){
                this.Toast("产品报价必须大于0")
                return false
            }
            let onePrice = {
                offer_unit_price : this.digitNum,
                detail_added : this.digitcomm
            }
            this.$emit("offerUnitPrice",JSON.stringify(onePrice))
        },
        loadOffer(val){
            if(val.tails && val.tails.wantOfferDetail){
                this.digitNum = parseFloat(val.tails.wantOfferDetail.offer_unit_price/100);
                this.digitcomm = val.tails.wantOfferDetail.detail_added;
            }else{
                this.digitNum = "";
                this.digitcomm= "";
            }
        }
    },
    watch : {
        clickOfferDetail(val,oldVal){
           this.loadOffer(val)
        }
    },
    mounted () {
        this.loadOffer(this.clickOfferDetail)
    },
}

</script>


<style lang='scss' scoped>
.offerAffirm{
    border-radius: 4px;
    width: 300px;
    .van-cell{
        padding: 0;
    }
    .aff-close{
        position: absolute;
        
    }
    .aff-bottom{
        background: #ffffff;
        padding: 15px 0;
        .ben-btn-r{
            height: 30px;
            line-height: 30px;
            width: 120px;
        }
    }
    .aff-info{
        margin: 10px;
        background: #F9F9F9;
        border: 1px solid #ccc;
        border-top: 0px solid #ccc;
        max-height: 150px;
        overflow-y: auto;
        .title-left{
            padding: 10px;
            border-top: 1px solid #ccc;
        }
        .title-right{
            padding: 10px;
            background: #E6E6E6;
            border-top: 1px solid #ccc;
            border-left: 1px solid #ccc;    word-break: break-all;
        }
    }
    .info-list-comm{
        margin:0 15px ;
        padding: 15px 0;
    }
    .aff-title{
        height: 45px;
        line-height: 45px;
        background: #C41335;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/offerAffirm.vue